export class EdSectionOptions {
  draggable: boolean;
  selectable: boolean;
  editable: boolean;
  objectOptions: { draggable: boolean; selectable: boolean; editable: boolean; };
  constructor(edition = false) {
    this.draggable = edition;
    this.selectable = true;
    this.editable = edition;
    this.objectOptions = { 
      draggable: edition,
      selectable: true,
      editable: edition
    };
  }
}